// extracted by mini-css-extract-plugin
export default {"image":"Valentines_image__Ic0dU","image-wrap":"Valentines_image-wrap__JW3Lj"};